import React, { useState, useEffect, useRef } from 'react';
import FlyUpModal from '../FlyUpModal';
import { getFontStylesAsync } from '../../../../utils/StoreConfigManager';
import './ImageCarouselModal.css';
import { isMobileDevice } from 'web-store-modules/packages/obsess-device-detector';
import ModalOverlay from '../ModalOverlay';
import { StaticImage } from 'web-store-modules/packages/modal-media';
import { AppContext } from '../../../../AppContext';
import { CarouselArrowClicked } from '../../../../utils/Analytics';
import { constructUrl } from '../../../../utils/UrlConstructor';
import { useTranslation } from 'react-i18next';
const isMobile = isMobileDevice();
const nextArrowUrl = "https://cdn.obsessvr.com/next-thumbnail-arrow.png";
const rightArrow = 'https://cdn.obsess-vr.com/dyson/right-arrow.png'
const leftArrow = 'https://cdn.obsess-vr.com/dyson/left-arrow.png'
const closeIcon = 'https://cdn.obsess-vr.com/dyson/close-icon-v2.png';
const localeRedirectCTA = {
    '6176daca9b2c20ab91603011': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/handbags/minibags',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/ハンドバッグ/mini-bags',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/bolsos/es-minibag',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/sacs-à-main/sac-mini-femmes',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/borse/mini-bag-donna',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/bolsos/minibags',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/handbags/mini-bag-woman',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/handtaschen/mini-bag-woman-de',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/handbags/mini-bag-woman',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/women-handbags/mini-bag',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/handbags/minibag-ca',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/핸드백/미니백-9'
    },
    '6176ddd2da91633089b266e6': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/shoes/pumps',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/シューズ/パンプス--10',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/zapatos/zapatos-de-salón',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/chaussures/décolletés',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/scarpe/décolleté-',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/zapatos/zapatos-de-salón',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/shoes/pumps-24',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/schuhe/pumps',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/shoes/pumps-',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/women-shoes/women-pumps',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/women/shoes/ca-pumps',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/슈즈-9/펌프스-9'
    },
    '6177422281bd4cfac427bd20': {
        'us_en': 'https://www.ferragamo.com/shop/us/en/shoes/pumps',
        'jpn_ja': 'https://www.ferragamo.com/shop/jpn/ja/シューズ/パンプス--10',
        'esp_es': 'https://www.ferragamo.com/shop/esp/es/zapatos/zapatos-de-salón',
        'fra_fr': 'https://www.ferragamo.com/shop/fra/fr/chaussures/décolletés',
        'ita_it': 'https://www.ferragamo.com/shop/ita/it/scarpe/décolleté-',
        'mex_es': 'https://www.ferragamo.com/shop/mex/es/zapatos/zapatos-de-salón',
        'eu_en': 'https://www.ferragamo.com/shop/eu/en/shoes/pumps-24',
        'eu_de': 'https://www.ferragamo.com/shop/eu/de/schuhe/pumps',
        'gb_en': 'https://www.ferragamo.com/shop/gb/en/shoes/pumps-',
        'aus_en': 'https://www.ferragamo.com/shop/aus/en/women-shoes/women-pumps',
        'ca_en': 'https://www.ferragamo.com/shop/ca/en/women/shoes/ca-pumps',
        'kor_kr': 'https://www.ferragamo.com/shop/kor/ko/슈즈-9/펌프스-9'
    }
}
const ImageCarouselModal = ({ modalContent, onModalHidden, hotspotId, currentSceneName }) => {
    const { t, i18n } = useTranslation()
    const { pages } = modalContent;
    const [fontStyles, setFontStyles] = useState();
    const modalRef = useRef();
    const [carouselWidth, setCarouselWidth] = useState();
    const [distOffset, setDistOffset] = useState(0);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [xTranslation, setXTranslation] = useState(0);
    const carouselContainer = useRef();
    const [title, setTitle] = useState('');
    const [subTitle, setSubTitle] = useState('');
    const totalItems = pages.length;
    console.log({hotspotId})
    useEffect(() => {
        fetchFontStyles();
        addListeners();
        setTitle(pages[0]?.title);
        setSubTitle(pages[0]?.subtitle);
        return (() => {
            removeListeners();
        });
    }, []);

    useEffect(() => {
        if (carouselContainer.current && carouselContainer.current.clientWidth)
            setCarouselWidth(carouselContainer.current.clientWidth);
    }, [carouselContainer.current]);

    useEffect(() => {
        setDistOffset(carouselWidth * currentIndex);
    }, [currentIndex, carouselWidth])

    useEffect(() => {
        setXTranslation(distOffset ? -distOffset : 0);
    }, [distOffset])

    const addListeners = () => {
        if (isMobile) {
            window.addEventListener('touchend', handleModalClose);
        } else {
            window.addEventListener('click', handleModalClose);
        }
    }

    const removeListeners = () => {
        if (isMobile) {
            window.removeEventListener('touchend', handleModalClose);
        } else {
            window.removeEventListener('click', handleModalClose);
        }
    }

    const fetchFontStyles = () => {
        getFontStylesAsync()
            .then((fontStyles) => setFontStyles(fontStyles))
            .catch((err) => console.error(err));

    }

    const handleModalClose = (e) => {
        if (modalRef && modalRef.current.contains(e.target)) {
            return;
        }
    }
    const textItem = () => {
        const productImageStyle = { display: 'inline', minWidth: '100%', minHeight: '100%', objectFit: 'contain', transition: 'all 500ms', padding: '0', transform: `translate(${xTranslation}px, 0px)` };

        return pages.map((x, i) => {
            return (
                <div className='text-modal-html-container' key={i} style={productImageStyle}>
                    {/* <span style={{ fontSize: isMobile ? '60px' : '24px', fontFamily: 'futura-light-bt', marginBottom: '5px' }}> {x.title} </span>
                    <p className="subtitle">{x.subtitle}</p> */}
                    <div className="modal-description">
                        <img src={constructUrl(x.image)} style={{height: '300px', paddingTop: '10px', maxWidth: '100%'}}/>
                        
                        <p className="description">{x.description}</p>
                    </div>
                </div>
            )
        })
    }

    const onclickHandler = (arrowType) => {
        if(arrowType == 'left-arrow'){
            setCurrentIndex(currentIndex - 1);            
        } else {
            setCurrentIndex(currentIndex + 1);            
        }
        //CarouselArrowClicked(currentSceneName);        
    }

    const textContainer = () => {
        return (
            <div className='text-modal-carousel' ref={carouselContainer} style={{overflowY: currentIndex == 0 ? 'hidden': 'auto'}}>
                {textItem()}
            </div>
        )
    }

    const arrowIndicatore = () => {
        return (
            <div className='text-modal-arrow'>
                {currentIndex > 0 && <div className="left-arrow" onClick={() => onclickHandler('left-arrow') }><img src={nextArrowUrl} alt='left-arrow' /></div>}
                {totalItems > 1 && (currentIndex + 1) < totalItems && <div className="right-arrow" onClick={() =>  onclickHandler('right-arrow') }><img src={nextArrowUrl} alt='right-arrow' /></div>}
            </div>
        )
    }

    const handleClick = () => {
        let url = (hotspotId === '6176daca9b2c20ab91603011') ? 'https://www.ferragamo.com/shop/us/en/women/handbags/minibags' : 'https://www.ferragamo.com/shop/us/en/women/shoes/pumps';

        if (localeRedirectCTA[hotspotId]) {
            if (localeRedirectCTA[hotspotId][i18n.language]) {
                url = localeRedirectCTA[hotspotId][i18n.language];
            }
        }
        window.open(url, '_blank');
    }

    const exploreButton = () => {
        return (
            <button  className="call-to-order-btn-wrapper explore share image-call-to-order" style={{ margin: '15px auto',cursor: 'pointer', border:'none', paddingRight: '0px' }} >
                <span className="call-to-order-btn" onClick={handleClick} style={{fontFamily: 'MessinaSans-Semibold', textTransform: 'uppercase', whiteSpace: 'nowrap', paddingRight: '0px'}} >{t('textModalCTA')}</span>
            </button>
        )
    }

    const renderModalContent = () => {
        return (
            <div className='text-modal-content' style={{ textAlign: 'center' }} ref={modalRef}>
                <div className='carousal-header'>
                    <span style={{ fontSize: isMobile ? '60px' : '24px', fontFamily: 'futura-light-bt', marginBottom: '5px' }}> {title} </span>
                    <p className="subtitle">{subTitle}</p>
                </div>
                {arrowIndicatore()}
                {textContainer()}
                {exploreButton()}
            </div>
        )
    }

    return (
        //Added the isImage Loaded bool here to display the close button on the Modal due to a condition in Modal.jsx
        <FlyUpModal extraClassName="text-modal-container" onModalHidden={onModalHidden} isOpaque
            textPopup hideCloseIcon isImageLoaded closeIconImage={closeIcon}>
            <ModalOverlay />
            {!!fontStyles && renderModalContent()}
        </FlyUpModal>
    );
}

export default props => (
    <AppContext.Consumer>
      {appContextValue => (
        <ImageCarouselModal {...props} currentSceneName = {appContextValue.currentSceneName}/>
      )}
    </AppContext.Consumer>
    );